module.exports = __webpack_public_path__ + "assets/img/btn-detail-2f69da8f.png";